/**
 * Post-login landing is the Cool workspace for every org.
 *
 * Do not race products (coverage → /coverage-risk, policy → /iq-hub, …).
 * Organization.landing_page is leftover per-product routing and is ignored.
 * Unenrolled products stay on this page as Learn more cards.
 */

export const UNIFIED_LANDING_PATH = '/workspace';

const LEARNING_ORGS = ['colibri-media-group', 'scav'];
const PLATFORM_ROLES = ['PLATFORM_ADMIN', 'PLATFORM_ENGINEER', 'PLATFORM_OWNER'];
const LEARNING_ROLES = ['STUDENT', 'LEARNER'];

function userFrom(authLike) {
  if (authLike && typeof authLike.getUser === 'function') {
    return authLike.getUser() || {};
  }
  return authLike || {};
}

function roleFrom(authLike, user) {
  if (authLike && typeof authLike.getUserRole === 'function') {
    return (authLike.getUserRole() || '').toUpperCase();
  }
  return (user.role || '').toUpperCase();
}

export function isForbiddenComplianceLanding(path) {
  if (!path || typeof path !== 'string') return false;
  const p = path.split('?')[0];
  return p === '/compliance' || p === '/compliance-health' || p.startsWith('/compliance-health/')
    || p === '/settings/organization';
}

/**
 * True when the org's features_enabled flag (or all_features) includes `feature`.
 */
export function orgHasProductFeature(org, feature) {
  if (!feature) return true;
  const flags = org?.features_enabled || {};
  if (flags.all_features) return true;
  return !!flags[feature];
}

/**
 * @param {object} [authLike] auth service or a user-shaped object
 * @returns {string} Vue router path
 */
export function resolveClientLandingPage(authLike) {
  const user = userFrom(authLike);
  const role = roleFrom(authLike, user);
  const slug = user?.organization?.slug || '';

  if (PLATFORM_ROLES.includes(role)) {
    return '/client-management';
  }
  if (LEARNING_ORGS.includes(slug) || LEARNING_ROLES.includes(role)) {
    return '/learning';
  }

  return UNIFIED_LANDING_PATH;
}
